import type { CreateClientConfig } from '../generated/uis/client.gen';
import {
  createFetchWithTimeout,
  ENDPOINT_ACCOUNT_API,
  ENDPOINT_ACCOUNT_API_TIMEOUT,
} from '../utils';

export const createClientConfig: CreateClientConfig = config => ({
  ...config,
  baseUrl: ENDPOINT_ACCOUNT_API,
  fetch: createFetchWithTimeout(({ method, url }) => {
    if (method === 'POST' && url.endsWith('/profile/my-trips')) {
      return 10_000; // OM-2236
    }

    return ENDPOINT_ACCOUNT_API_TIMEOUT;
  }),
});
